<ng-container [formGroup]="paymentOptionsForm">
    <p class="my-2 text-slate-600 text-sm">
        By clicking 'Pay now', you will submit the request for processing.
    </p>

    <br>

    <p *ngIf="paymentInitiation === cancelPlanFlow" data-auto-id="make-payment-contact-for-help">
        If you have any questions, please contact us at 
        <span [innerHTML]="contactNumber | phone:true" appGaButtonClick [buttonLocation]="cancelPlanFlow"
                    [buttonName]="contactPhoneBtnName"></span>
    </p>
    
    <div class="flex flex-row mb-2" *ngIf="paymentInitiation !== cancelPlanFlow">
        <p-checkbox
            ariaLabel="Terms and Conditions Checkbox"
            formControlName="termsAndConditions"
            value="Agree"
            inputId="termsAndConditions"
            data-auto-id="make-payment-terms-and-conditions-checkbox"
        />
        <label for="termsAndConditions" class="ml-2">I agree to the </label>
        <a 
            tabindex="0"
            class="text-blue-700 pl-1 mt-0 cursor-pointer"
            (keydown.enter)="onTermsAndConditions()"
            (click)="onTermsAndConditions()"
            data-auto-id="make-payment-terms-and-conditions-link"
        >
            &nbsp;terms and conditions
        </a>
    </div>
</ng-container>

